export default __webpack_public_path__ + "static/media/spinner.83505abe.svg";